/* eslint-disable */
import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import globalReducer from './global';
import { isLocalhost } from '../utils/utils';

// createStore
export const store = configureStore({
  // reducer合并
  reducer: {
    global: globalReducer,
  },
  // 禁用rudex调试工具
  devTools: isLocalhost,
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
